"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "barberino-di-mugello": {
    "f4370d3e": [{
      "hkey": "1af95d38",
      "slug": "barberino-di-mugello",
      "name": "Barberino di Mugello",
      "primary": true,
      "skipSearch": false
    }],
    "cagaggiolo": [{
      "hkey": "1af95d38",
      "slug": "barberino-di-mugello",
      "name": "Barberino di Mugello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bca9a5b7": [{
      "hkey": "1af95d38",
      "slug": "barberino-di-mugello",
      "name": "Barberino di Mugello",
      "primary": true,
      "skipSearch": false
    }],
    "casaglia-poggiolino": [{
      "hkey": "1af95d38",
      "slug": "barberino-di-mugello",
      "name": "Barberino di Mugello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f6374952": [{
      "hkey": "1af95d38",
      "slug": "barberino-di-mugello",
      "name": "Barberino di Mugello",
      "primary": true,
      "skipSearch": false
    }],
    "montecuccoli": [{
      "hkey": "1af95d38",
      "slug": "barberino-di-mugello",
      "name": "Barberino di Mugello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;